import history from '../history';
import moment from "moment";
let humanizeDuration = require('humanize-duration');
import { v4 as uuidv4 } from 'uuid';

import numeral from "numeral";


export default class Helpers{
    static goTo(href, replace=false){
        switch(replace){
            case true:
                history.replace({pathname: href});
                break;
            case false:
                history.push({pathname: href});
                break;
        }
    }

    static formatNumber(value, format="0.00") {
        return numeral(value).format(format);
    }

    static goToNewTab(url){
        let win = window.open(url, "_blank");
        win.focus();
    }

    static checkFieldErrors(fields, fields_dict){
        let results = {
            pass: true,
            fields: {}
        };

        for(let f of fields){
            let field_error = false;
            if(!fields_dict.hasOwnProperty(f) || fields_dict[f] === "" || fields_dict[f] === false){
                field_error = true;
                results.pass = false;
            }
            results.fields[f] = field_error;
        }

        return results;
    }

    static formatDate(date_str, format="dddd DD MMMM HH:mm"){
        return Helpers.formatUtcDate(date_str, format);
    }

    static formatUtcDate(date_str, format="dddd DD MMMM HH:mm"){
        let date = new Date(date_str);
        return moment(date).format(format);
    }

    static formatNumeralInt(nb) {
        return Number(nb.toFixed(0)).toLocaleString();
    }

    static format_time_eco(minutes){
        return humanizeDuration(minutes * 60 * 1000, {
            language: "shortFr",
            units: ['d', 'h', 'm'],
            round: true,
            conjunction: ' ',
            serialComma: false,
            languages: {
                shortFr: {
                    y: function() { return 'ans'; },
                    mo: function() { return 'm'; },
                    w: function() { return 's'; },
                    d: function() { return 'j'; },
                    h: function() { return 'h'; },
                    m: function() { return 'mins'; },
                    s: function() { return 'secs'; },
                    ms: function() { return 'ms'; }
                }
            }
        });
    }

    static format_co2_eco(grams, isNumeralInt = false){
        let w = parseFloat(grams);
        let it = 0;
        let units = ["g", "kg", "T"];
        while(w > 1000 && it < 2){
            w = w / 1000;
            it++;
        }
        if(it > 2)
            it = 2;

        if (isNumeralInt)
            return this.formatNumeralInt(w) + " " + units[it];

        return w.toFixed(2).toString() + " " + units[it];
    }

    static trimChar(string, charToRemove) {
        while(string.charAt(0)===charToRemove)
            string = string.substring(1);

        while(string.charAt(string.length-1)===charToRemove)
            string = string.substring(0,string.length-1);

        return string;
    }

    static isMobile(){
        let check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    }

    static scrollOnClick(id){
        let elt = document.getElementById(id);
        let ctn = document.getElementById("container");
        ctn.scrollTo(elt.offsetLeft < 31 ? 0 : elt.offsetLeft - 15, 0);
    }

	static exportData(text, filename) {
		let pom = document.createElement('a');
		pom.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
		pom.setAttribute('download', filename + '.csv');
		pom.style.display = 'none';
		document.body.appendChild(pom);
		pom.click();
		document.body.removeChild(pom);
    }
    
    static uniqId() {
        // return new Date().getTime().toString(36).substr(2, 9);
        return uuidv4();
    };
}



// WEBPACK FOOTER //
// ./src/Utils/Helpers.js